import React, { useRef, useEffect, useState } from "react";
import "./gs-tooltip.scss";
import { createPortal } from "react-dom";

export type GSTooltipProps = {
  text: string,
  position: {
    x: number,
    y: number,
  },
};

export function GSTooltip(props: GSTooltipProps) {
  const tooltipRef = useRef(null);
  const [newPos, setNewPos] = useState(props.position);

  const { text, title, position } = props;

  useEffect(() => {
    if (tooltipRef.current) {
      const tooltipHeight = tooltipRef.current.offsetHeight;
      setNewPos({ x: position.x, y: position.y - tooltipHeight });
    }
  }, [position]);

  return createPortal(
    <div ref={tooltipRef} style={{ top: newPos.y, left: newPos.x }} className="gs-tooltip">
      {title && <h5 className="gs-tooltip-title">{title}</h5>}
      <div className="gs-tooltip-text" dangerouslySetInnerHTML={{ __html: text }} />
    </div>,
    document.body,
  );
}
